import i18n from 'i18next';

export function columnsCurrencies() {
  return [
    {
      id: 'currency_code',
      label: i18n.t('column.currency_code'),
      minWidth: 30,
      align: 'left',
      format: (value) => value.toLocaleString('en-US'),
    },
    {
      id: 'currency_name',
      label: i18n.t('column.currency_name'),
      minWidth: 40,
      align: 'left',
      format: (value) => value.toLocaleString('en-US'),
    },
    {
      id: 'currency_numeric',
      label: i18n.t('column.currency_numeric'),
      minWidth: 50,
      align: 'left',
      format: (value) => value.toLocaleString('en-US'),
    },
    {
      id: 'currency_symbol',
      label: i18n.t('column.currency_symbol'),
      minWidth: 50,
      align: 'left',
      format: (value) => value.toLocaleString('en-US'),
    },
  ];
}
